import React, { useState } from "react";
import { Modal, Input, Button, message } from "antd";
import { addCategory } from "../useCategoryAPI";

const AddCategoryModal = ({ showAddCategoryModal, setShowAddCategoryModal, fetchCategories }) => {
  const [newCategory, setNewCategory] = useState("");

  const handleAddCategory = async () => {
    if (!newCategory.trim()) {
      message.error("Category name cannot be empty!");
      return;
    }

    try {
      const response = await addCategory(newCategory);
      message.success(`Category "${newCategory}" added successfully!`);
      fetchCategories();
      setNewCategory(""); 
      setShowAddCategoryModal(false); 
    } catch (error) {
      message.error(error?.response?.data?.message || "Failed to add category. Please try again.");
    }
  };

  return (
    <Modal
      title="Add Category"
      open={showAddCategoryModal}
      onCancel={() => setShowAddCategoryModal(false)}
      footer={null}
      style={{ textAlign: "center" }}
      centered
    >
      <div style={{ textAlign: "center" }}>
        <Input
          placeholder="Enter Category Name"
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
          style={{
            marginTop: "20px",
            width: "80%",
            height: "40px",
            borderRadius: "4px",
            border: "1px solid #E0E0E0",
          }}
        />
        <div style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            style={{
              backgroundColor: "#FF6B35",
              border: "none",
            }}
            onClick={handleAddCategory}
          >
            Add
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AddCategoryModal;
